import { useState } from "react";
import Match from "./pages/Match";

function App() {
  const [init, setInit] = useState(false);
  const [scores, setScores] = useState([]);

  if (!init) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <h1
          className="bg-accent text-white font-semibold rounded-md cursor-pointer px-4 py-2"
          onClick={() => setInit(true)}
        >
          Initialize
        </h1>
      </div>
    );
  }

  return (
    <div className="h-full flex items-center justify-center bg-accent text-background">
      <Match scores={scores} setScores={setScores} />
    </div>
  );
}

export default App;
